/*
 * @Author: chenchaoqiang@leedarson.com
 * @Date: 2022-08-02 17:27:05
 * Copyright 2022 Leedarson, All Rights Reserved.
 */
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import useNewSubscription from '@root/hooks/newSubscription/useNewSubscription';
import { PackageCard } from '@root/components/Package';
import { IPackage } from '@root/types/package';
import Button from '@root/components/Button';
import PageLoading from '@root/components/PageLoading';
import PageLoadError from '@root/components/PageLoadError';
import SafeAreaInset from '@root/components/SafeAreaInset';
import Empty from '@root/components/Empty';

const SubscriptionList = () => {
  const { t } = useTranslation();
  const {
    state: {
      packages,
      selectedPackage,
      paying,
      loading,
      unBindDevices,
      changePackageId,
    },
    action: { onSelected, onClickPay, getPackageList },
  } = useNewSubscription();

  // 下一步是否去 PayPal 支付
  const isContinue = useMemo(
    () => unBindDevices.length || changePackageId,
    [changePackageId, unBindDevices.length],
  );

  if (loading < 1) {
    return <PageLoading />;
  }

  if (loading === 2) {
    return <PageLoadError onTryAgain={getPackageList} />;
  }

  return (
    <>
      <div className="flex-section-auto navbar-spacing">
        {/* <CellTitle enhance>{t('gift_card_use_1', { cycle: '' })}</CellTitle> */}
        {packages.length ? (
          packages.map((item: IPackage) => {
            return (
              <PackageCard
                key={item.goodsId}
                title={item.goodsName}
                priceList={item.goodsPriceList}
                checkedPriceId={selectedPackage?.checkedPriceId}
                description={item.description}
                onSelected={(priceId: string) => onSelected(item, priceId)}
                maxDevNum={item.maxDevNum}
                className={
                  selectedPackage?.goodsId === item.goodsId ? 'active' : ''
                }
              />
            );
          })
        ) : (
          <Empty>{t('check_products_empty')}</Empty>
        )}
      </div>
      <div className="flex-section-footer">
        {packages.length ? (
          <Button
            disabled={!selectedPackage?.goodsId}
            loading={paying}
            onClick={onClickPay}
          >
            {isContinue ? t('purchase_now') : t('pay_with_PayPal')}
          </Button>
        ) : null}
        <SafeAreaInset />
      </div>
    </>
  );
};

export default SubscriptionList;
